import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Divider, FormControlLabel,
  IconButton, Radio,
  RadioGroup, Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers';
import { useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import { getRequest, postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import * as Yup from 'yup';
import { handleErrorMessages } from '../../risk-register/feching';

const GenratePayrollSettingsModal = ({ open, onClose, currentItem, reload }) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const [ entryType, setEntryType ] = useState('Manual');
  const [ employees, setEmployees ] = useState([]);
  const [ selectedEmployeeId, setSelectedEmployeeId ] = useState('');
  console.log("🚀 ~ GenratePayrollSettingsModal ~ selectedEmployeeId:", selectedEmployeeId)


  const [selectedDay, setSelectedDay] = useState();
  const PayrollSchema = Yup.object().shape({

  });
  const defaultValues = useMemo(
    () => ({

    }),
    []
  );

  useEffect(() => {
    const fetchEmployees = async () => {
      const res = await getRequest(endpoints.accounting.employee.get_list);
      if (res) setEmployees(res);
    };
    fetchEmployees();
  }, []);

  const methods = useForm({
    resolver: yupResolver(PayrollSchema),
    defaultValues,
  });

  const {
    reset,
    control,
    value,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const handleTypeChange = (e) => {
    setEntryType(e.target.value);
  };
  useEffect(() => {
    if (open) {
      reset({ ...defaultValues });
      setSelectedEmployeeId(currentItem?.employee_id || '');
    }
  }, [ open, reset, defaultValues, currentItem ]);

  const onSubmit = handleSubmit(async (data) => {
    try {
      const formData = new FormData();
      formData.append('week_end_day', selectedDay); // Pass selected day (Sunday, Monday, etc.)
      const result = await postRequest(
        currentItem?.id
          ? `${endpoints.accounting.payroll.generate_payroll.create_settings}/${currentItem.id}?_method=PUT`
          : endpoints.accounting.payroll.generate_payroll.create_settings,
        formData,
        true
      );
      if (result.metadata?.success) {
        reset();
        onClose();
        enqueueSnackbar("Settings created successfully", { variant: 'success' });
      } else {
        handleErrorMessages(result?.metadata?.message);
      }
    } catch (err) {
      enqueueSnackbar('Submission failed', { variant: 'error' });
      console.error(err);
    }
  });
  const isDisabled = entryType === 'ai_generated';

  return (
    <Dialog
      open={ open }
      onClose={ (event, reason) => reason !== 'backdropClick' && onClose() }
      fullWidth
      maxWidth="md"
      sx={ {
        borderRadius: 'none',
        padding: '2px',
        fontSize: '13px',
        fontFamily: 'arial',
      } }
      transitionDuration={ {
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      } }
    >
      <FormProvider methods={ methods } onSubmit={ onSubmit }>
        <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between' } }>
          <span className="cardColor" style={ { padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' } }>
            { currentItem?.id ? 'Update Settings' : 'Create Settings' }
          </span>
          <IconButton onClick={ onClose }>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={ { pt: 0 } }>
          {/* <Box display="flex" justifyContent="flex-start" mb={ 2 }>
            <RadioGroup
              row
              value={ entryType }
              onChange={ handleTypeChange }
              name="entryType"
            >
              <FormControlLabel value="manual" control={ <Radio /> } label="Manual Entry" />
              <FormControlLabel value="ai_generated" control={ <Radio /> } label="AI Entry" />
            </RadioGroup>
          </Box> */}
          {/* <Typography variant="h6" gutterBottom>WHD Payroll Tax Settings</Typography> */ }
          <Box display="grid" gridTemplateColumns={ { xs: '1fr', sm: '1fr 1fr' } } gap={ 2 }>
          </Box>
          <Typography variant="h6" mt={ 3 } gutterBottom>General Settings</Typography>
          <Box display="grid" gridTemplateColumns={ { xs: '1fr', sm: '1fr 1fr' } } gap={ 2 }>
            <RHFTextField name="revised" label="Revised" disabled={ isDisabled } />
            <RHFTextField name="omb" label="OMB" disabled={ isDisabled } />
            <Controller
              name="expires"
              disabled={ isDisabled }
              control={ control }
              render={ ({ field, fieldState: { error } }) => (
                <DatePicker
                  label="Expires"
                  { ...field }
                  format="MM-dd-yyyy"
                  slotProps={ {
                    textField: {
                      fullWidth: true,
                      error: !!error,
                      helperText: error?.message,
                    },
                  } }
                />
              ) }
            />
          </Box>
          <Box display="grid" gridTemplateColumns={ { xs: '1fr', lg: '1fr' } }>
            <RadioGroup row defaultValue="g">
              <FormControlLabel value="g" control={ <Radio size="medium" /> } label="WHERE FRINGE BENEFITS ARE PAID IN CASH" />
              <FormControlLabel value="p" control={ <Radio size="small" /> } label="WHERE FRINGE BENEFITS ARE PAID TO APPROVED PLANS, FUNDS, OR PROGRAMS" />
            </RadioGroup>
          </Box>
          <Divider />
          <Box mt={ 3 }>
            <RadioGroup
              row
              value={ selectedDay }
              onChange={ (e) => setSelectedDay(e.target.value) } // Update state on change
            >
              <FormControlLabel value="Monday" control={ <Radio size="small" /> } label="Monday" />
              <FormControlLabel value="Tuesday" control={ <Radio size="small" /> } label="Tuesday" />
              <FormControlLabel value="Wednesday" control={ <Radio size="small" /> } label="Wednesday" />
              <FormControlLabel value="Thursday" control={ <Radio size="small" /> } label="Thursday" />
              <FormControlLabel value="Friday" control={ <Radio size="small" /> } label="Friday" />
              <FormControlLabel value="Saturday" control={ <Radio size="small" /> } label="Saturday" />
              <FormControlLabel value="Sunday" control={ <Radio size="small" /> } label="Sunday" />
            </RadioGroup>
          </Box>


        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={ onClose }>
            Close
          </Button>
          <LoadingButton type="submit" variant="contained" className="dark-button" loading={ isSubmitting } disabled={ isDisabled }>
            { currentItem?.id ? 'Update' : 'Submit' }
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default GenratePayrollSettingsModal;